import { render, staticRenderFns } from "./FloatingTradePanel.vue?vue&type=template&id=9b9f33ce&scoped=true"
import script from "./FloatingTradePanel.vue?vue&type=script&setup=true&lang=js"
export * from "./FloatingTradePanel.vue?vue&type=script&setup=true&lang=js"
import style0 from "./FloatingTradePanel.vue?vue&type=style&index=0&id=9b9f33ce&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9b9f33ce",
  null
  
)

export default component.exports